var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company" },
    [
      _c("span", { staticClass: "company-name" }, [_vm._v("单位：")]),
      _vm._v(" "),
      _c(
        "el-select",
        {
          attrs: {
            value: _vm.value,
            placeholder: "请选择",
            disabled: _vm.isClick
          },
          on: { change: _vm.companyFn }
        },
        _vm._l(_vm.options, function(item) {
          return _c("el-option", {
            key: item.code,
            attrs: { label: item.name, value: item.code }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }